import React from "react";
import ReactDOM from "react-dom/client";
import "./lib/browserErrorGuards";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { configureAmplifyAuth } from "./lib/amplifyAuth";

configureAmplifyAuth();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
